import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useFeatureFlags } from '@/helper/FeatureFlags';
import { useAppConfig } from '@/hooks/useAppConfig';
import { getContentTypeOptions } from '@/modules/corporate/modules/admin/views/LearningContent/helpers/getContentType';

import SingleSelect from '../Select/SingleSelect';
import { FilterValueProps } from '../types';

function ContentTypeFilter(props: FilterValueProps) {
  const { t } = useTranslation();
  const appConfig = useAppConfig();
  const featureFlags = useFeatureFlags();
  const { filterValue, onFilterValueChange, disabled, error } = props;

  const options = useMemo(
    () =>
      getContentTypeOptions(t, appConfig, featureFlags).map((item) => ({
        ...item,
        id: item.value,
      })),
    [appConfig, featureFlags, t],
  );

  return (
    <SingleSelect
      disabled={disabled}
      error={error}
      filterValue={filterValue}
      options={options}
      onChange={onFilterValueChange}
    />
  );
}

export default ContentTypeFilter;
